import { Component, inject, OnInit } from "@angular/core";
import { ThemeService } from "../../../../../shared/src/lib/services/theme.service";
import { Router } from "@angular/router";
import { LoaderService } from "../../../../../shared/src/lib/services/loader.service";
import { Observable } from "rxjs";
import { AsyncPipe } from "@angular/common";
import { SafeHtmlPipe } from "../../../../../shared/src/lib/pipe/safe-html.pipe";

@Component({
    selector: "app-footer",
    imports: [AsyncPipe, SafeHtmlPipe],
    templateUrl: "./footer.component.html",
    styleUrl: "./footer.component.scss"
})
export class FooterComponent implements OnInit {
  themeService = inject(ThemeService);
  router = inject(Router);
  loader = inject(LoaderService);
  loading$!: Observable<boolean>;
  template: string = "";

  ngOnInit() {
    this.loading$ = this.loader.isLoading("/footer.html");
    this.getTemplate();
  }

  getTemplate() {
    this.themeService.fetchFooterTemplate().subscribe({
      next: (html: string) => {
        this.template = html;
      },
    });
  }
}
